import { requestV2 } from "./index";

const queryUsage = async <T>(reqData: unknown) => {
  return requestV2<T>({ method: "get", url: `/api/credits/logs`, params: reqData });
};

export default {
  queryUsage,
};
